<template>
    <div id="homepage" class="parallax custom-margin-top" style="background-color: rgb(28, 80, 87);">
        <div class="content h-100">
            <div class="row justify-content-center align-items-center custom-content-height">
                <div class="col-10">
                    <p class="display-4 font-italic">Welcome to Bitcoin.com Games Affiliates</p>
                    <h2 class="font-italic pt-1 sub-title" style="font-weight: 800 !important;">Get paid for referring users to our Casino</h2>
                    <button v-on:click="register()" type="button" class="btn btn-primary custom-btn mt-5 btn-lg">REGISTER NOW</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {registrationLink} from '../assets/js/registration';
    import {mapActions} from "vuex";

    export default {
        name: "HomePage",
        methods: {
            ...mapActions([
                'setActiveTab',
            ]),
            registrationLink,
            register() {
                this.setActiveTab('');
                this.registrationLink();
            }
        }
    }
</script>

<style scoped>
    @media (min-width: 576px) {
        .custom-margin-top {
            margin-top: 85px;
        }
        .display-4 {
            font-size: calc(2.5rem + 5vmin);
        }
        .sub-title {
            font-size: calc(1.5rem + 3vmin);
        }
        .custom-content-height {
            height: 80%;
        }
        .parallax {
            /* The image used */
            background-image: url('~@/assets/home.png');

            /* Full height */
            height: 100vh;

            /* Create the parallax scrolling effect */
            background-attachment: fixed;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
    }

    @media (max-width: 576px) {
        .custom-margin-top {
            margin-top: 60px;
        }
        .display-4 {
            font-size: calc(1rem + 5vmin);
        }
        .sub-title {
            font-size: calc(0.5rem + 3vmin) !important
        }

        .custom-content-height {
            height: 90%;
        }

        .parallax {
            /* The image used */
            background-image: url('~@/assets/home.png');

            /* Full height */
            height: 80vh;

            /* Create the parallax scrolling effect */
            background-attachment: fixed;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
    }

    .content {
        color: white;
        text-align: center;
        /*padding-top: 13%;*/
    }

    .btn-primary.custom-btn {
        background-color: #00C58A;
        border-color: #00C58A;
        color: white;
        font-weight: bold;
        padding: 15px;
        padding-left: 30px;
        padding-right: 30px;
        font-family: Lato;
        font-weight: bold;
        font-size: calc(1rem + 3vmin);
    }

    .display-4 {
        font-weight: 800 !important;
        margin-bottom: 0px;
    }
</style>